import React, { useEffect, useState, useRef } from 'react';
import logo from './logo.jpg'; // Make sure the logo path is correct
import './AboutTureMedicine.css';

const AboutTureMedicine = () => {
  const [showText, setShowText] = useState(false);
  const [showImage, setShowImage] = useState(false);

  const textRef = useRef(null);  // Reference for text content
  const imageRef = useRef(null); // Reference for image content

  const handleScroll = () => {
    // Ensure the refs are available and the elements are not null
    if (textRef.current && imageRef.current) {
      const textPosition = textRef.current.getBoundingClientRect().top;
      const imagePosition = imageRef.current.getBoundingClientRect().top;
      const screenHeight = window.innerHeight;

      if (textPosition < screenHeight && textPosition > 0) {
        setShowText(true);
      } else {
        setShowText(false);
      }

      if (imagePosition < screenHeight && imagePosition > 0) {
        setShowImage(true);
      } else {
        setShowImage(false);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <section className="about-turemedicine-section">
      <div
        ref={textRef}
        className={`text-content ${showText ? 'show' : ''}`}
      >
        <h2>About TureMedicine</h2>
        <p>
          TureMedicine is a telehealthcare service provider committed to offering
          accessible healthcare services to everyone, regardless of their location in India.
        </p>
      </div>
      <div
        ref={imageRef}
        className={`image-content ${showImage ? 'show' : ''}`}
      >
        <img src={logo} alt="TureMedicine Logo" />
      </div>
    </section>
  );
};

export default AboutTureMedicine;
